import { createContext } from 'react';

import { DragAndDropProviderProps } from './drag-and-drop.types';

// Configuration context for stable values that rarely change
export interface ConfigContextValue
  extends Pick<
    DragAndDropProviderProps,
    'direction' | 'disabled' | 'enableAutoScroll' | 'scrollContainer'
  > {
  readonly instanceId: symbol;
  readonly announceToScreenReader: (message: string) => void;
}

export const ConfigContext = createContext<ConfigContextValue | null>(null);
